import * as React from "react";
import { useState } from "react";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { ModelPortfolioTabType } from "../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { ResultPageModel } from "../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { ModelPortfolio } from "../../../../../Wrap/Models/Models/Instruments/ModelPortfolio";
import { Table } from "../../../Table/Table";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { AllocationTableItem } from "../../Store/SelectedInvesmentStoreStatic";
import { UnderlyingTable } from "../Shared/UnderlyingTable";

interface IPortfolioResultsProps {
    data: ResultPageModel<ModelPortfolio>;
    allocationTable: AllocationTableItem[];
    onPageChange: (pageIndex) => void;
}
export const PortfolioResults = (props: IPortfolioResultsProps) => {
    if (!props.data) {return null;}

    const [currentPage, setCurrentPage] = useState(1);

    const _data = JSON.parse(JSON.stringify(props.data));
    _data.Results = props.data.Results.map((ele) => {
        const isSelected = props.allocationTable.some((item) => item.Instrument.ProductId == ele.ProductId);
        return { isSelected: isSelected, ...ele };
    });

    return (
        <div className="panel pr-0 pl-0 pb-0 pt-0 mt-40">
            <h3>Selection</h3>
            <p>Hub Portfolios available: {props.data.Pager.TotalRecords}</p>
            <Table
                data={_data.Results}
                cssWrapper={"no-sided-padding table-expandable"}
                showEmptyMsg
                needPagination={{
                    totalNumOfResult: props.data.Pager.TotalRecords,
                    currentPage: currentPage,
                    onPaginationChange: (pageIndex) => {
                        setCurrentPage(pageIndex);
                        props.onPageChange(pageIndex);
                    },
                }}
                col={[
                    {
                        title: "Portfolio",
                        key: "Name",
                        toogleOptions: (row, index) => {
                            return {
                                toogleable: true,
                                expandContent: (
                                    <UnderlyingTable
                                        data={row.underlying.ModelPortfolioProducts}
                                        modelPortfolioType={row.modelPortfolioType}
                                        isTps={row.ProductType == ProductType.TailoredModelPortfolio}
                                    />
                                ),
                            };
                        },
                    },
                    {
                        title: "Type",
                        key: "Type",
                        render: (data, row, index) => {
                            return data == ProductType.ManagedModelPortfolio ? "MPS (incl PPM)" : "IMA";
                        },
                    },
                    { title: "Investment manager", key: "ManagerName" },
                    {
                        title: <span className="sr-only">select an investment</span>,
                        key: "isSelected",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row) => {
                            return (
                                <a
                                    className={"select-toggle"}
                                    onClick={() =>
                                        data
                                            ? null
                                            : InvestmentSelectionAction.addInvestment(
                                                  row,
                                                  ModelPortfolioTabType.HubModel
                                              )
                                    }
                                    aria-pressed={data}
                                >
                                    <span className="label">{data ? "Added" : "Select"}</span>
                                </a>
                            );
                        },
                    },
                ]}
            />
        </div>
    );
};
